import { PrepareInfo } from "../../../api/pricelist.types";
import { PricelistPrepareInfoAction, PricelistPrepareInfoState } from "./pricelist.prepare_info.types";

export const pricelistPrepareInfoRequestAction = (params: { pls_id: number }): PricelistPrepareInfoAction => ({ type: 'PRICELIST_PREPARE_INFO_REQUEST', params })

export const pricelistPrepareInfoSuccessAction = (prepareInfo: PrepareInfo): PricelistPrepareInfoAction => ({ type: 'PRICELIST_PREPARE_INFO_SUCCESS', params: prepareInfo })

export const pricelistPrepareInfoFailureAction = (error?: any) => ({ type: 'PRICELIST_PREPARE_INFO_FAILURE' } as const)

export const pricelistPrepareInfoModalSetAction = (modal: PricelistPrepareInfoState['modal']): PricelistPrepareInfoAction => ({ type: 'PRICELIST_PREPARE_INFO_MODAL_SET', params: modal })